import { type } from './is';
/**
 * 判断一个react node是否是空
 *
 * @export
 * @param {import('react').ReactNode} node react node
 * @returns 是否为空
 */

export function isNodeEmpty(node) {
  switch (type(node)) {
    case 'String':
      return !node.trim();

    case 'Array':
      return !node.length || node.every(isNodeEmpty);

    default:
      return node == null;
  }
}